module.exports = __webpack_public_path__ + "static/media/left.1a36d5c0.svg";